import React from 'react';
import { useAppContext } from '../../store/appContext';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import { ColumnCell, ColumnGrid } from '../../common/css_global/mobile/utils.css';
import { MainBodyWrapper, PageWrapper } from './App.css';
import EuCookieBanner from '../../components_common/EuCookieBanner/EuCookieBanner';
import UnsupportedBrowser from '../../components_common/UnsupportedBrowser/UnsupportedBrowser';
import Banner from '../../components_common/Banner';
import checkUnsupportedBrowser from '../../helpers/checkUnsupportedBrowser';
import { requiresCookieBanner } from '../../helpers/helpers';
import { useShippingSelector } from '../../hooks/useShippingSelector';
import timerQueue, { EventType } from '../../helpers/TimerQueue';

const App = ({ children }) => {
  // Initialize Google Analytics through react-ga
  const { browserIsNotSupported, browserName } = checkUnsupportedBrowser();
  const { euCookiePolicyAccepted, isEu, overflowScroll, page, currPage } = useAppContext();
  const overflowy = page === 'Home';
  const { isShippingSelectorVisible, changeShippingVisibility } = useShippingSelector();

  return (
    <PageWrapper>
      <Banner />
      <Header
        changeShippingVisibility={changeShippingVisibility}
        isShippingSelectorVisible={isShippingSelectorVisible}
        currPage={currPage}
      />
      <MainBodyWrapper id="main" overflowy={overflowy} overflowScroll={overflowScroll}>
        <ColumnGrid id="grid">
          <ColumnCell style={{ minHeight: '81vh' }}>
            {browserIsNotSupported ? <UnsupportedBrowser browserName={browserName} /> : <>{children}</>}
          </ColumnCell>
          <ColumnCell id="footer">
            <Footer changeShippingVisibility={changeShippingVisibility} />
          </ColumnCell>
        </ColumnGrid>
        {requiresCookieBanner(isEu, euCookiePolicyAccepted) && (
          <EuCookieBanner
            handleClick={() => {
              timerQueue.addEvent({
                callback: () => window.location.reload(),
                type: EventType.Navigation,
              });
            }}
          />
        )}
      </MainBodyWrapper>
    </PageWrapper>
  );
};

export default App;
